module.exports = __webpack_public_path__ + "static/media/strengthstore4.ba99e3f2.jpg";